export const MyConsultationEn = {
    xunjiadang:'My advice',
    quanbu:'whole',
    zhixunzhong:'Consultation',
    yijieshu:'Has ended',
    zuanjiaxinxi:'Expert information',
    zixunjindu:'Consultation progress',
    caozuo:'operation'
}


// WEBPACK FOOTER //
// ./src/lang/member/MyConsultation/MyConsultationEn.js